module.exports = __webpack_public_path__ + "img/5.6f24566a.png";